export enum C3GraphicType {
    Stock = 'Stock',
    Customer = 'Customer',
    OneOff = 'One-off',
}
